import React, { useEffect, useState } from "react";
import "./index.css";
import {
  GlobalConfiguration,
  ScreenSizeConfiguration,
} from "../../../utils/configurationProvider";

const CommonLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="main-grid-container">
      {!isMobile ? (
        <>
          <div className="main-grid-container-div ">
            {React.Children.map(children, (item, index) => {
              if (
                index % GlobalConfiguration.lengthCheckTwo ===
                GlobalConfiguration.lengthCheckZero
              ) {
                return item;
              }
            })}
          </div>
          <div className="main-grid-container-div ">
            {React.Children.map(children, (item, index) => {
              if (
                index % GlobalConfiguration.lengthCheckTwo !==
                GlobalConfiguration.lengthCheckZero
              ) {
                return item;
              }
            })}
          </div>
        </>
      ) : (
        <div className="main-grid-container-mobilediv">
          {React.Children.map(children, (item) => item)}
        </div>
      )}
    </div>
  );
};

export default CommonLayout;
